//doctor-ws.js
import { HttpMethod } from 'app/utils/network';
import { API } from 'app/utils/request';

export const addDoctor = (doctorRequest, authToken) => {
  const urlPath = '/doctor/adddoctor';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: doctorRequest,
    additionalHeader: additionalHeader
  });
};

export const updateDoctorDetails = (doctorRequest, authToken) => {
  const urlPath = '/doctor/updateDoctor';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: doctorRequest,
    additionalHeader: additionalHeader
  });
};

export const getAllDoctorDetails = (authToken) => {
  const urlPath = '/doctor/getAllDoctorDetails';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const getSelectedDoctorDetails = (doctorId, authToken) => {
  const urlPath = `/doctor/getSelectedDoctorDetails/${doctorId}`;
  const additionalHeader = {
    Authorization: `Bearer`
  };
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};
